import { createCustomAction } from 'typesafe-actions';

import { AuthenticationMethod } from '../../utils/Api';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$FETCH_SALE_STATUS/REQUESTED';
const BLOCKED = '$FETCH_SALE_STATUS/BLOCKED';
const APPROVED = '$FETCH_SALE_STATUS/APPROVED';
const SUCCEEDED = '$FETCH_SALE_STATUS/SUCCEEDED';
const FAILED = '$FETCH_SALE_STATUS/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      authenticationMethod: AuthenticationMethod;
    }>(type);
};

const succeed = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      saleDetails: Sale;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
